import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState = {
  loading: false,
  errorMessage: null,
  successMessage: null,
};

const apiUrl = 'api/upload/eleves';

export const uploadEleveCreation = createAsyncThunk(
  'eleve/upload_creation',
  async ({ ecoleId, file }: { ecoleId: string; file: FormData }, thunkAPI) => {
    const result = await axios.post<string>(`${apiUrl}/creation?ecoleId=${ecoleId}`, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const uploadEleveUpdate = createAsyncThunk(
  'eleve/upload_update',
  async ({ ecoleId, file }: { ecoleId: string; file: FormData }, thunkAPI) => {
    const result = await axios.post<string>(`${apiUrl}/mise-a-jour?ecoleId=${ecoleId}`, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const uploadEleveInscription = createAsyncThunk(
  'eleve/upload_inscription',
  async ({ ecoleId, anneeScolaireId, file }: { ecoleId: string; anneeScolaireId: string; file: FormData }, thunkAPI) => {
    const result = await axios.post<string>(`${apiUrl}/inscription?ecoleId=${ecoleId}&anneeScolaireId=${anneeScolaireId}`, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const uploadEleveReinscription = createAsyncThunk(
  'eleve/upload_reinscription',
  async ({ ecoleId, anneeScolaireId, file }: { ecoleId: string; anneeScolaireId: string; file: FormData }, thunkAPI) => {
    const result = await axios.post<string>(`${apiUrl}/reinscription?ecoleId=${ecoleId}&anneeScolaireId=${anneeScolaireId}`, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result;
  },
  { serializeError: serializeAxiosError }
);

export type UploadState = Readonly<typeof initialState>;
export const UploadSlice = createSlice({
  name: 'uploads',
  initialState: initialState as UploadState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addMatcher(
        isFulfilled(uploadEleveCreation, uploadEleveUpdate, uploadEleveInscription, uploadEleveReinscription),
        (state, action) => {
          state.loading = false;
          state.successMessage = action.payload.data;
          state.errorMessage = null;
        }
      )
      .addMatcher(isPending(uploadEleveCreation, uploadEleveUpdate, uploadEleveInscription, uploadEleveReinscription), state => {
        state.loading = true;
        state.errorMessage = null;
        state.successMessage = null;
      })
      .addMatcher(isRejected(uploadEleveCreation, uploadEleveUpdate, uploadEleveInscription, uploadEleveReinscription), (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'An error occurred';
      });
  },
});

export const { reset } = UploadSlice.actions;

export default UploadSlice.reducer;
